import { Grid, Paper, Typography, CircularProgress } from '@mui/material';
import { useLoadData } from '../../../../hooks/useLoadData';
import { ApiResponse } from '../../../../models/api-response';
import { ReactElement, useState } from 'react';
import { Icons } from '../../../../assets/icons';
import { officeApiKeyStore } from '../../../../api/office-api-key-store';
import { ProfileStatistics } from '../../../../models/profileStatistics';
import graphImg from '../../../../assets/icons/dummy-graph.png';
import { BarChartComponent } from '../../../customers/customer-details/widgets/bar-chart.component';

const styling = {
  paperStyle: { padding: '20px', borderRadius: '10px' },
  icontStyle: { stroke: '#ffffff', strokeWidth: 1, width: 80, height: 80 },
};
interface OfficeStatisticsProps {
  officeID: any;
}
interface ComponentCell {
  label: string;
  count: any;
  isLoading: any;
  element: ReactElement;
}
const ComponentCell = ({ label, count, isLoading, element }: ComponentCell) => {
  return (
    <Paper elevation={0} style={styling.paperStyle}>
      <Grid container direction="row" justifyContent="space-between">
        <Grid item>
          <Grid container direction="column" justifyContent="center" alignItems="center">
            {element}
            <Typography variant="body1">{label}</Typography>
          </Grid>
        </Grid>
        <Grid item display={'flex'}>
          <Grid container justifyContent="flex-end" alignItems="flex-end">
            {!isLoading ? <Typography variant="h4">{count}</Typography> : <CircularProgress />}
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export const OfficeStatistics = ({ officeID }: OfficeStatisticsProps) => {

  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const { data, isLoading } = useLoadData<ApiResponse<ProfileStatistics>>(
    officeApiKeyStore.getOfficeProfileStatistics(officeID, startDate, endDate)
  );

  const handleDateRange = (startDate: string, endDate: string) => {
    setStartDate(startDate);
    setEndDate(endDate);
  }

  return (
    <Grid container spacing={2} className="detailsBoxContainer">
      <Grid item lg={6} sm={6} xl={6} xs={6} className="solidBlueBox detailsBox">
        <ComponentCell
          label="PROJECTS"
          isLoading={isLoading}
          count={data?.data.countProjects}
          element={<img src={Icons.ProjectHandDetails} alt="Projects" />}
        />
      </Grid>
      <Grid item lg={6} sm={6} xl={6} xs={6} className="gradientGreenBox detailsBox">
        <ComponentCell
          label="LOTS/UNITS"
          isLoading={isLoading}
          count={data?.data.countLotsUnits}
          element={<img src={Icons.LotsUnitsDetails} alt="Lots/Units" />}
        />
      </Grid>

      {/* <Grid item lg={12} sm={12} xl={12} xs={12} className="detailsBox">
        <Paper elevation={0}>
          <Grid container direction="row">
            <Grid item>
              <Grid container direction="column" justifyContent="center" alignItems="center">
                <Typography variant="body1">
                  <img src={graphImg} style={{ width: '100%' }} />
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
        <div className="head">WORK ORDERS</div>
          <div className="contentChart"></div>
      </Grid> */}
      <Grid item lg={12} sm={12} xl={12} xs={12} className="detailsBox">
        <BarChartComponent staticData={data?.data} onDateRange={handleDateRange} />
      </Grid>
    </Grid>
  );
};
